import style from './Right.module.scss';

import { SelectButtonMenu } from '@components/SelectButtonMenu';

import { useBlockHeaderActions } from './hooks/useBlockHeaderActions';

export interface RightParams {
    blockId: string;
    version: number;
}

export function Right({ blockId, version }: RightParams) {
    const { title, items, disabled, onClick } = useBlockHeaderActions({ blockId, version });

    return (
        <div className={style.root}>
            <div className={style.button}>
                <SelectButtonMenu
                    title={title}
                    items={items}
                    disabled={disabled}
                    onButtonClick={onClick}
                />
            </div>
        </div>
    );
}
